const tpl = (str) =>
  `${str} 계정 업그레이드가 필요합니다. 안내 페이지로 이동하시겠습니까?`

export default {
  buttons: {
    add: '추가',
    save: '저장',
    search: '검색',
    delete: '삭제',
    cancel: '취소',
    confirm: '확인',
    complete: '완료',
    importMemos: '메모 가져오기',
    selfInput: '직접 입력하기',
    close: '닫기'
  },
  alerts: {
    login: '로그인이 필요합니다'
  },
  words: {
    memo: '메모',
    book: '도서',
    tos: '이용약관',
    privacyPolicy: '개인정보처리방침',
    or: '혹은',
    tag: '태그',
    sort: '정렬'
  },
  labels: {
    id: '아이디',
    email: '이메일',
    password: '비밀번호'
  },
  messages: {
    hasAccount: '이미 계정이 있으신가요?',
    appUpdateRequired: '앱 업데이트가 필요합니다.'
  },
  noti: {
    headers: {
      upgrade: '계정 업그레이드 필요',
      login: '로그인 필요'
    },
    messages: {
      userAccessExcerpts: tpl('메모당 2개 보다 많은 발췌문을 추가하려면'),
      userAccessMemos: tpl('100개 보다 많은 메모를 추가하려면'),
      userAccessQuota: tpl('할당량 이상으로 사용하시려면'),
      userAccessPdfExporting: tpl('메모를 PDF로 내보내시려면'),
      userAccess: tpl('해당 기능을 이용하시려면'),
      signInNeeded: '로그인이 필요합니다. 로그인 페이지로 이동하시겠습니까?',
      equalPlatformRequired: '구독하신 플랫폼에서 구독 변경을 해주세요.',
      fileNeeded: '파일을 추가해주세요.',
      charsExceeded: '허용되는 글자 수를 초과하였습니다 ({num}/{max})'
    }
  },
  services: {
    ridi: '리디북스',
    millie: '밀리의서재'
  },
  terms: {
    readgraphyLogo: 'readgraphy logo',
    review: '서평',
    earlybird: '얼리버드',
    month: '월',
    year: '년',
    tag: '태그',
    readgraphy: '리드그라피',
    paidPlan: '유료 플랜',
    freePlan: '무료 플랜',
    planInfo: '서비스 플랜 안내',
    allTags: '모든 태그',
    korean: '한글',
    english: '영어',
    aladin: '알라딘',
    gbooks: '구글북스',
    logout: '로그아웃',
    addTag: '태그 추가',
    noTags: '태그 없음 (우측 버튼으로 생성)',
    billedMonthly: '매월 청구',
    billedAnnual: '매년 청구',
    deleteAccount: '계정삭제',
    share: '공유',
    download: '다운로드',
    backToLibrary: '내 서재로 돌아가기',
    myLibrary: '내 서재',
    getStarted: '시작하기',
    numSelected: '{count}개 선택',
    close: '닫기',
    copy: '복사',
    notice: '알림'
  },
  noty: {
    ADDED: '추가 완료',
    UPDATED: '업데이트 완료',
    IMPORTED: '가져오기 완료',
    SENT: '전송 완료',
    URL_COPIED: 'URL 복사됨',
    ONLINE_RECOVERY: '인터넷 연결됨',
    OFFLINE: '인터넷 연결되지 않음',
    RETRY: '재시도',
    ERROR_PERMISSION: '실패 - 잘못된 데이터',
    ERROR_ITEMS_EXCEEDED: '실패 - 갯수 초과',
    ERROR_INVALID_AUTH: '실패 - 계정 정보 에러',
    ERROR_INVALID_PROVIDER: '실패 - 지원되지 않는 타입',
    ERROR_PAYMENT_DECLINED: '실패 - 구독 결제',
    ERROR_UNKNOWN: '실패 - 에러 발생',
    ERROR_NOT_FOUND: '실패 - 찾을 수 없는 데이터',
    ERROR_NO_QUOTA: '실패 - 할당량 초과',
    ERROR_ADMIN_CONTACT: '실패 - 관리자 문의 핊요'
  },
  routes: {
    signup: '가입하기',
    signin: '로그인',
    searchBook: '추가할 책 검색',
    myLibrary: '내 서재',
    toc: '목차',
    forgot: '비밀번호 변경',
    privacy: '개인정보처리방침',
    tos: '이용약관',
    settings: '설정',
    tags: '태그',
    pricing: '서비스 플랜 안내',
    services: '서비스 목록',
    serviceRegister: '{service}에서 가져오기',
    deleteAccount: '계정삭제',
    shareExcerpt: '발췌문 이미지로 공유',
    highlighting: '하이라이트',
    charts: '독서량 차트',
    addToList: '메모리스트에 추가',
    notelists: '메모 리스트',
    review: '서평',
    reviewEdit: '서평 작성'
  }
}
